import React from 'react'
import Slider from 'react-slick'
import { motion } from 'framer-motion'
import logo from '../assets/images/logo_without_text.png'
import furqan from '../assets/team/furqan.png'
import usama from '../assets/team/usama.png'
import shahzaib from '../assets/team/shahzaib.png'
import ahmad from '../assets/team/ahmad.png'
import aqdas from '../assets/team/aqdas.png'
import humair from '../assets/team/humair.png'
import zahid from '../assets/team/zahid.png'
import gull from '../assets/team/gull.png'
import arif from '../assets/team/arif.png'
import rehman from '../assets/team/rehman.jpg'







const Team = () => {
  const team = [
    {
      name: "Usama Zahid",
      img: zahid,
      designation: "Bussiness Development Officer"
    },
    {
      name: "Gull Husnain",
      img: gull,
      designation: "Agentic AI Engineer"
    },
     {
      name: "Usama Arif",
      img: arif,
      designation: "Project Manager"
    },
    {
      name: "Muhammad Usama Tahir",
      img: usama,
      designation: "Backend Developer"
    },
    {
      name: "Muhammad Furqan",
      img: furqan,
      designation: "Frontend Developer, UI/UX Designer"
    },
    {
      name: "Shahzaib Qasim",
      img: shahzaib,
      designation: "MERN Stack Developer"
    },
    {
      name: "Abdul Rehman",
      img: rehman,
      designation: "Flutter Developer"
    },
    {
      name: "Ahmad Asghar",
      img: ahmad,
      designation: "Flutter Developer"
    },
    {
      name: "Aqdas Rehman",
      img: aqdas,
      designation: "AI/ML Developer"
    },
     {
      name: "Humair Yousaf",
      img: humair,
      designation: "AI/ML Developer"
    },
    
    
  ]

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <div>
      <div className='grid grid-cols-1 gap-5 my-8'>
        <h1 className='text-center text-4xl font-bold mb-7'>Our Team</h1>
        <Slider {...settings}>
          {team.map(({ name, img, designation }, index) => {
            const sName = name.split(" ")
            const fName = name.split(" ").length === 3 ? `${sName[0]} ${sName[1]}` : sName[0]
            const lName = name.split(" ").length === 3 ? sName[2] : sName[1]
            return (
              <motion.div
                key={index}
                className='px-5 relative'
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.15,
                  ease: "easeOut"
                }}
                whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0,0,0,0.15)" }}
              >
                <img className='w-20 absolute z-10' src={logo} alt={name} />
                
                <img className='drop-shadow rounded-2xl' src={img} alt={name} />
                <h1 className='text-2xl font-semibold my-2'>
                  {fName} <span className='text-primaryColor'>{lName}</span>
                </h1>
                <h1 className='text-sm'>{designation}</h1>
              </motion.div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}

export default Team
